// extracted by mini-css-extract-plugin
module.exports = {"root":"AssetLink_root__jlSaN"};